import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFeatureGateByPlanEnabled } from "../../../redux/reducers/FeatureGate";
import { ReduxState } from "../../../redux";
import ClipLoader from "react-spinners/ClipLoader";

type Props = { featureId: number; renderEnabled; renderNotEnabled };
export const FeatureGateByPlan: React.FC<Props> = ({
  featureId,
  renderEnabled,
  renderNotEnabled,
}) => {
  const dispatch = useDispatch();
  const { featureGatesByPlanEnabled, loading } = useSelector(
    (state: ReduxState) => state.FeatureGate
  );
  React.useEffect(() => {
    dispatch(fetchFeatureGateByPlanEnabled(featureId));
  }, []);

  if (loading) {
    return <ClipLoader />;
  }
  if (featureGatesByPlanEnabled[featureId]) {
    return <>{renderEnabled && renderEnabled()}</>;
  }

  return <>{renderNotEnabled && renderNotEnabled()}</>;
};
export default FeatureGateByPlan;
